var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 40,
    width: 42,
    height: 40,
    transform: "rotate(180 42 40)",
    fill: "url(#pattern0_24_85)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_24_85",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_24_85",
    transform: "matrix(0.015625 0 0 0.0164063 0 -0.025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_24_85",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABAEAQAAABQ8GUWAAAAIGNIUk0AAHomAACAhAAA+gAAAIDoAAB1MAAA6mAAADqYAAAXcJy6UTwAAAACYktHRAAAqo0jMgAAAAlwSFlzAAAAYAAAAGAA8GtCzwAAAAd0SU1FB+cMDxEuDqtdkaEAAAGmSURBVHja7Zs5igJBGIWrFUXB2MBMTMwUPYInEFwCTQXvYGTuHTyCiA0uCOIZDEXMRelMXOtNNhPMYNtlD9XLe3FV9/99tTRdUEJ8GCCbBUYjwLIgdzug34eMxz99ri8CFIvA8YhfWa8hUynd9WmCD4EEyHQaOBxgF7lcAsmk7nr/QcBgYAsfZAmQi8XbAjwuIaLUy9jvnbWvVAQmE69KcBwgnwfOZ0ezIGgbI2S9Dtzvjh14eDkoSKjVgNst5DOBEiiBEiiBEiiBEiiBEijBXoLCvwMlUAIlUAIlUAIlUEIoJKDRUJMwnwMRtSN+r0VdQreru3b3JCgtB9NUeZc3p40RjTrv9HzqLtuVQLbbwOPheAXITkd37frgYZq+3wSBZlP9C5BI6K6f8IQnPOEJT3jCE57whCc84QlPeMITnvCEDz58q6V2gDmd+h9eFgrA9RrKkRdCCGA4DOXIfwuQq1VQ4BUvTW027zeezYSoVg3jctEN61qATAY4nfw88i5IKJdfSwjIhvdaQqn0t4QQwP9IyOWA8RiwLGC7BXo9yFhMd13v5guAIUkjkP8BxQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.0eea4872a88130c5c98ab3721243b455.svg";
export { ForwardRef as ReactComponent };